import React from "react";
import ReactModal from "react-modal";
import styles from "./Overlay.scss";

export const Overlay = ({ maxWidth, maxHeight, onRequestClose, shouldCloseOnOverlayClick, children }) => {
  const contentStyle = { maxWidth, maxHeight };
  return (
    <ReactModal
      className={styles.content}
      overlayClassName={styles.overlay}
      style={{ content: contentStyle }}
      isOpen
      contentLabel="StyledModal"
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      onRequestClose={onRequestClose}
    >
      {children}
    </ReactModal>
  );
};
